import React from 'react';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from 'material-ui/TextField';
import InputMask from 'react-input-mask';
import CircularProgress from '@material-ui/core/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import Divider from 'material-ui/Divider';

import urlBase from '../../../url-base';
import axios from 'axios';


class ImageDocForm extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      id: '',
      cpf: '',
      name: '',
      imagesDocId: '',

      loadingSave: false,
      success: null,
      validCpf: false,
      loadingCpf: false
    };

    this.styles = {
      sendFormSuccess: {
        padding: 10,
        color: '#155724',
        backgroundColor: '#d4edda',
        borderColor: '#c3e6cb'
      },
      sendFormError: {
        padding: 10,
        color: '#721c24',
        backgroundColor: '#f8d7da',
        borderColor: '#f5c6cb'
      }
    };

    // Campos obrigatórios
    this.errorField = {
      cpf: ''
    };
  }


  componentDidMount() {
    
  }

  // Monitora mudanças a atualiza estados dos inputs text
  onChange(e) {
    let state = this.state;
    state[e.target.name] = e.target.value;

    if (e.target.value == '')
      this.errorField[e.target.name] = 'Campo obrigatório';
    else
      this.errorField[e.target.name] = '';

    this.setState(state);
  }

  onBlurField(e) {
    this.validateCpf(e.target.value);      
  }

  validateCpf(cpf) {
    let state = this.state;
    let test = true;
    let add = 0, i = 0, rev = 0;
    let cpfMask = cpf;

    cpf = cpf.replace(/[^0-9]/g,'');

    if (cpf.length != 11 || 
        cpf == "00000000000" || 
        cpf == "11111111111" || 
        cpf == "22222222222" || 
        cpf == "33333333333" || 
        cpf == "44444444444" || 
        cpf == "55555555555" || 
        cpf == "66666666666" || 
        cpf == "77777777777" || 
        cpf == "88888888888" || 
        cpf == "99999999999") {
      test = false;
    }
    else {
      // Valida 1° digito	
      for (i=0; i < 9; i ++)		
        add += parseInt(cpf.charAt(i)) * (10 - i);	
        rev = 11 - (add % 11);	
        if (rev == 10 || rev == 11)
          rev = 0;

        if (rev != parseInt(cpf.charAt(9)))
          test = false;          	

      // Valida 2° digito	
      add = 0;	
      for (i = 0; i < 10; i ++)
        add += parseInt(cpf.charAt(i)) * (11 - i);

      rev = 11 - (add % 11);	

      if (rev == 10 || rev == 11)
        rev = 0;

      if (rev != parseInt(cpf.charAt(10)))
        test = false;
    }

    if (test == true) {
      this.errorField.cpf = '';
      this.countFinancialManager(cpfMask);
    }
    else {
      this.errorField.cpf = 'CPF inválido';
      state.validCpf = false;
    }

    state.success = null;
    this.setState(state);
  }

  countFinancialManager(cpf) {
    let url = urlBase.loopBack + 'ImagesDocs/getImagesByCpf';
    let state = this.state;

    state.validCpf = false;
    state.loadingCpf = true;
    this.setState(state);

    let dataSubmit = {
      cpf: cpf
    };

    axios.post(url, dataSubmit)
    .then((response) => {
      let state = this.state;

      // Se existir uma venda completa com o mesmo cpf
      if (response.data.fullSale == true) {
        state.validCpf = false;
        this.errorField.cpf = 'Resp. Financeiro já cadastrado';
        state.id = '';
        state.name = '';
        state.imagesDocId = '';
      }
      else {
        // Se existir imagens dos docs desse interessado
        if (response.data.imagens) {
          for (let key in response.data.imagens) {
            // Se existir a imagem do documento
            if (response.data.imagens[key].length > 0) {
              // Pega a extensão do arquivo
              let ext = response.data.imagens[key].split('.').pop().toLowerCase();

              if (ext == 'pdf') {
                document.getElementById('name_file_pdf_'+key).style.display = 'inherit';
                document.getElementById('name_file_'+key).style.display = 'none';
              }
              else {
                document.getElementById('name_file_pdf_'+key).style.display = 'none';
                document.getElementById('name_file_'+key).style.display = 'inherit';
                document.getElementById('name_file_'+key).src = urlBase.loopBack + 'attachments/docs/download/' + response.data.imagens[key];
              }
            }
          }

          if (response.data.financialManagerId.length > 0)
            state.id = response.data.financialManagerId;
          if (response.data.financialManagerName.length > 0)
            state.name = response.data.financialManagerName;
          if (response.data.imagesDocId.length > 0)
            state.imagesDocId = response.data.imagesDocId;

        }

        state.validCpf = true;
        this.errorField.cpf = '';
      }

      state.loadingCpf = false;
      this.setState(state);
    })
    .catch(function () {
      let state = this.state;
      state.id = '';
      state.name = '';
      state.imagesDocId = '';
      this.errorField.cpf = 'Erro ao pesquisar CPF.';
      state.validCpf = false;
      state.loadingCpf = false;
      this.setState(state);
    }.bind(this));
  }

  fileToBase64(typeDoc) {
    /*
    * @type pode ser: "cpf", "rg", "rg2", "resid", "credtFrontal", "physicalContract", "adtive"
    */

    let reader = new FileReader();
    let file = document.getElementById('doc_'+typeDoc).files[0];
    let ext = file.name.split('.').pop().toLowerCase();

    if (ext == 'pdf') {
      document.getElementById('name_file_pdf_'+typeDoc).style.display = 'inherit';
      document.getElementById('name_file_'+typeDoc).style.display = 'none';
    }
    else {
      document.getElementById('name_file_pdf_'+typeDoc).style.display = 'none';
      document.getElementById('name_file_'+typeDoc).style.display = 'inherit';
      document.getElementById('name_file_'+typeDoc).src = window.URL.createObjectURL(file);
    }

    reader.onloadend = function() {
      document.getElementById('imagem_'+typeDoc).value = reader.result;
    }.bind(this);
    reader.readAsDataURL(file);
  }

  onSubmitForm() {
    // Caso não tenha erro no cpf
    if (this.state.cpf.replace(/\D/g, '').length == 11 && this.state.validCpf == true) {
      let state = this.state;
      state.loadingSave = true;
      this.setState(state);
      document.getElementById('i_loading_send_doc').scrollIntoView();
  
      let dataSubmit = {
        id: this.state.id,
        cpf: this.state.cpf,
        name: this.state.name,
        imagesDocId: this.state.imagesDocId,
        imagesDocs: {
          cpf: document.getElementById('imagem_cpf').value,
          rg: document.getElementById('imagem_rg').value,
          rg2: document.getElementById('imagem_rg2').value,
          address: document.getElementById('imagem_resid').value,
          credtFrontal: document.getElementById('imagem_credtFrontal').value,
          physicalContract: document.getElementById('imagem_physicalContract').value,
          adtive: document.getElementById('imagem_adtive').value,
          others: document.getElementById('imagem_others').value
        }
      };

      axios.post(urlBase.loopBack + 'ImagesDocs/saveDocsFinancialManager', dataSubmit)
      .then(() => {
        let state = this.state;
        state.loadingSave = false;
        state.success = true;
        this.setState(state);
        document.getElementById('i_loading_send_doc').scrollIntoView();
        this.stateDefault();
      })
      .catch(() => {
        let state = this.state;
        state.loadingSave = false;
        state.success == false;
        this.setState(state);
        document.getElementById('i_loading_send_doc').scrollIntoView();
      });
    }
    else {
      if (this.state.cpf.replace(/\D/g, '').length < 11) {
        let state = this.state;
        this.errorField.cpf = 'Campo obrigatório.';
        state.validCpf = false;
        state.loadingCpf = false;
        this.setState(state);
      }
      document.getElementById('i_cpf').scrollIntoView(false);
    }

  }

  stateDefault() {
    let state = this.state;
    state.cpf = '';
    state.name = '';
    this.setState(state);

    // base64
    document.getElementById('imagem_cpf').value = '';
    document.getElementById('imagem_rg').value = '';
    document.getElementById('imagem_rg2').value = '';
    document.getElementById('imagem_resid').value = '';
    document.getElementById('imagem_credtFrontal').value = '';
    document.getElementById('imagem_physicalContract').value = '';
    document.getElementById('imagem_adtive').value = '';
    document.getElementById('imagem_others').value = '';

    // Imagem
    document.getElementById('name_file_cpf').src = '/assets/images/icons/scan.png';
    document.getElementById('name_file_rg').src = '/assets/images/icons/scan.png';
    document.getElementById('name_file_rg2').src = '/assets/images/icons/scan.png';
    document.getElementById('name_file_resid').src = '/assets/images/icons/scan.png';
    document.getElementById('name_file_credtFrontal').src = '/assets/images/icons/scan.png';
    document.getElementById('name_file_physicalContract').src = '/assets/images/icons/scan.png';
    document.getElementById('name_file_adtive').src = '/assets/images/icons/scan.png';
    document.getElementById('name_file_others').src = '/assets/images/icons/scan.png';

    document.getElementById('name_file_cpf').style.display = 'inherit';
    document.getElementById('name_file_rg').style.display = 'inherit';
    document.getElementById('name_file_rg2').style.display = 'inherit';
    document.getElementById('name_file_resid').style.display = 'inherit';
    document.getElementById('name_file_credtFrontal').style.display = 'inherit';
    document.getElementById('name_file_physicalContract').style.display = 'inherit';
    document.getElementById('name_file_adtive').style.display = 'inherit';
    document.getElementById('name_file_others').style.display = 'inherit';

    // PDF
    document.getElementById('name_file_pdf_cpf').style.display = 'none';
    document.getElementById('name_file_pdf_rg').style.display = 'none';
    document.getElementById('name_file_pdf_rg2').style.display = 'none';
    document.getElementById('name_file_pdf_resid').style.display = 'none';
    document.getElementById('name_file_pdf_credtFrontal').style.display = 'none';
    document.getElementById('name_file_pdf_physicalContract').style.display = 'none';
    document.getElementById('name_file_pdf_adtive').style.display = 'none';
    document.getElementById('name_file_pdf_others').style.display = 'none';
  }


  render() {
    return (
      <div>
        <Paper id="i_loading_send_doc" style={{padding: 10}}>
          {/* Mensagem de retorno do formulário */
            this.state.success != null ? (
              this.state.success == true ? (/* Formulário salvo com sucesso */
          <Grid container spacing={24} style={{marginTop:30}}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <div style={{textAlign: 'center'}}>
                <p style={this.styles.sendFormSuccess}>Salvo com sucesso</p>
              </div>
            </Grid>
          </Grid>
              ) : (/* Erro ao enviar formulário */
          <Grid container spacing={24} style={{marginTop:30}}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <div style={{textAlign: 'center'}}>
                <p style={this.styles.sendFormError}>Erro ao salvar documentos</p>
              </div>
            </Grid>
          </Grid>
              )
            ) : ('')
          }

          {
            this.state.loadingCpf == true ? (
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <div style={{textAlign: 'center'}}>
              <CircularProgress />
              <p>Pesquisando CPF...</p>
            </div>
          </Grid>
            ) : ('')
          }


          {/* Loading de salvar o formulário */
            this.state.loadingSave == true ? (
          <Grid container spacing={24} style={{marginTop:30}}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <div style={{textAlign: 'center'}}>
                <CircularProgress />
                <p>Enviando...</p>
              </div>
            </Grid>
          </Grid>
            ) : ('')
          }

          <div>
            <input id="imagem_cpf" type="hidden"/>
            <input id="imagem_rg" type="hidden"/>
            <input id="imagem_rg2" type="hidden"/>
            <input id="imagem_resid" type="hidden"/>
            <input id="imagem_credtFrontal" type="hidden"/>
            <input id="imagem_physicalContract" type="hidden"/>
            <input id="imagem_adtive" type="hidden"/>
            <input id="imagem_others" type="hidden"/>

            <Grid container spacing={24}>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <TextField
                  id="i_cpf"
                  errorText={this.errorField.cpf}
                  style={this.styles.inputs}
                  hintText="CPF Resp. Financeiro"
                  floatingLabelText="CPF Resp. Financeiro *"
                  type="tel"
                  name="cpf"
                  value={this.state.cpf}
                  fullWidth={true}
                  onChange={(e) => this.onChange(e)}
                  onBlur={(e) => this.onBlurField(e)}
                >
                  <InputMask
                    mask="999.999.999-99" maskChar=" " name="cpf" value={this.state.cpf}
                  />
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} md={8} lg={8}>
                &nbsp;
                {/* <TextField
                  style={this.styles.inputs}
                  hintText="Nome do Responsável Financeiro"
                  floatingLabelText="Nome do Responsável Financeiro"
                  type="text"
                  name="name"
                  value={this.state.name}
                  fullWidth={true}
                  onChange={(e) => this.onChange(e)}
                /> */}
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} style={{textAlign: 'center'}}>
                <label htmlFor="doc_rg" style={{cursor:'pointer'}}>
                  RG (Frente)<br /><br />
                  <img
                    id="name_file_rg"
                    src={urlBase.client+'/assets/images/icons/scan.png'}
                    width="85"
                  />
                  <i
                    id="name_file_pdf_rg"
                    style={{display: "none"}}
                    className="far fa-file-pdf fa-6x"
                  >
                    &nbsp;
                  </i>
                </label>
                <input
                  id="doc_rg"
                  style={{visibility:"hidden",position:'absolute',left: -9999}}
                  type="file"
                  name="rg"
                  onChange={this.fileToBase64.bind(this, 'rg')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} style={{textAlign: 'center'}}>
                <label htmlFor="doc_rg2" style={{cursor:'pointer'}}>
                  RG (Verso)<br /><br />
                  <img
                    id="name_file_rg2"
                    src={urlBase.client+'/assets/images/icons/scan.png'}
                    width="85"
                  />
                  <i
                    id="name_file_pdf_rg2"
                    style={{display: "none"}}
                    className="far fa-file-pdf fa-6x"
                  >
                    &nbsp;
                  </i>
                </label>
                <input
                  id="doc_rg2"
                  style={{visibility:"hidden",position:'absolute',left: -9999}}
                  type="file"
                  name="rg2"
                  onChange={this.fileToBase64.bind(this, 'rg2')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} style={{textAlign: 'center'}}>
                <label htmlFor="doc_cpf" style={{cursor:'pointer'}}>
                  CPF<br /><br />
                  <img
                    id="name_file_cpf"
                    src={urlBase.client+'/assets/images/icons/scan.png'}
                    width="85"
                  />
                  <i
                    id="name_file_pdf_cpf"
                    style={{display: "none"}}
                    className="far fa-file-pdf fa-6x"
                  >
                    &nbsp;
                  </i>
                </label>
                <input
                  id="doc_cpf"
                  style={{visibility:"hidden",position:'absolute',left: -9999}}
                  type="file"
                  name="cpf"
                  onChange={this.fileToBase64.bind(this, 'cpf')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} style={{textAlign: 'center'}}>
                <label htmlFor="doc_resid" style={{cursor:'pointer'}}>
                  Comprovante de Residência<br /><br />
                    <img
                      id="name_file_resid"
                      src={urlBase.client+'/assets/images/icons/scan.png'}
                      width="85"
                    />
                  <i
                    id="name_file_pdf_resid"
                    style={{display: "none"}}
                    className="far fa-file-pdf fa-6x"
                  >
                    &nbsp;
                  </i>
                </label>
                <input
                  id="doc_resid"
                  style={{visibility:"hidden",position:'absolute',left: -9999}}
                  type="file"
                  name="resid"
                  onChange={this.fileToBase64.bind(this, 'resid')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} style={{textAlign: 'center'}}>
                <label htmlFor="doc_credtFrontal" style={{cursor:'pointer'}}>
                  Cartão de Crédito<br /><br />
                  <img
                    id="name_file_credtFrontal"
                    src={urlBase.client+'/assets/images/icons/scan.png'}
                    width="85"
                  />
                  <i
                    id="name_file_pdf_credtFrontal"
                    style={{display: "none"}}
                    className="far fa-file-pdf fa-6x"
                  >
                    &nbsp;
                  </i>
                </label>
                <input
                  id="doc_credtFrontal"
                  style={{visibility:"hidden",position:'absolute',left: -9999}}
                  type="file"
                  name="credtFrontal"
                  onChange={this.fileToBase64.bind(this, 'credtFrontal')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} style={{textAlign: 'center'}}>
                <label htmlFor="doc_physicalContract" style={{cursor:'pointer'}}>
                  Proposta de Adesão<br /><br />
                  <img
                    id="name_file_physicalContract"
                    src={urlBase.client+'/assets/images/icons/scan.png'}
                    width="85"
                  />
                  <i
                    id="name_file_pdf_physicalContract"
                    style={{display: "none"}}
                    className="far fa-file-pdf fa-6x"
                  >
                    &nbsp;
                  </i>
                </label>
                <input
                  id="doc_physicalContract"
                  style={{visibility:"hidden",position:'absolute',left: -9999}}
                  type="file"
                  name="physicalContract"
                  onChange={this.fileToBase64.bind(this, 'physicalContract')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} style={{textAlign: 'center'}}>
                <label htmlFor="doc_adtive" style={{cursor:'pointer'}}>
                  Aditivo de Carência<br /><br />
                  <img
                    id="name_file_adtive"
                    src={urlBase.client+'/assets/images/icons/scan.png'}
                    width="85"
                  />
                  <i
                    id="name_file_pdf_adtive"
                    style={{display: "none"}}
                    className="far fa-file-pdf fa-6x"
                  >
                    &nbsp;
                  </i>
                </label>
                <input
                  id="doc_adtive"
                  style={{visibility:"hidden",position:'absolute',left: -9999}}
                  type="file"
                  name="adtive"
                  onChange={this.fileToBase64.bind(this, 'adtive')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} style={{textAlign: 'center'}}>
                <label htmlFor="doc_others" style={{cursor:'pointer'}}>
                  Outro<br /><br />
                  <img
                    id="name_file_others"
                    src={urlBase.client+'/assets/images/icons/scan.png'}
                    width="85"
                  />
                  <i
                    id="name_file_pdf_others"
                    style={{display: "none"}}
                    className="far fa-file-pdf fa-6x"
                  >
                    &nbsp;
                  </i>
                </label>
                <input
                  id="doc_others"
                  style={{visibility:"hidden",position:'absolute',left: -9999}}
                  type="file"
                  name="others"
                  onChange={this.fileToBase64.bind(this, 'others')}
                />
              </Grid>
            </Grid>

            <Divider
              style={{width: '100%',marginTop:60}}
            />

            <Grid container spacing={24} style={{marginTop:20,marginBottom: 20, textAlign: 'center'}}>
              <Grid item style={{textAlign:'center'}} xs={12} sm={12} md={12} lg={12}>
                <RaisedButton
                  label="Enviar documentos"
                  primary={true}
                  onClick={this.onSubmitForm.bind(this)}
                />
              </Grid>
            </Grid>
          </div>
        </Paper>
      </div>
    );

  }

}

export default ImageDocForm;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/ImageDoc/ImageDocForm.js
 **/